import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'

import { colours } from '../settings/settings'

const MySelect = ({
  id,
  value,
  options = [],
  optionLabels,
  label = 'Label',
  variant = 'filled',
  onChange = () => {},
  helperText = '',
  errorText = '',
  autoSelect = true,
  disabled = false,
  readOnly = false,
  showEmpty = false,
  mode,
}) => {
  const isMobile = useSelector(state => state.home.isMobile)

  const [hasBlurred, setHasBlurred] = useState(false)

  const isNumeric = options.every(op => typeof op === 'number')

  const isError =
    !disabled &&
    !options.includes(value) &&
    (mode === 'update' || ((!mode || mode === 'add') && hasBlurred))

  const isReadOnly = readOnly || mode === 'view'

  const isNotInOptions = !options.includes(value)

  useEffect(() => {
    if (autoSelect && !disabled && !isReadOnly)
      if (options?.length === 1 && value !== options?.[0]) onChange(options[0])
  }, [autoSelect, disabled, isReadOnly, onChange, options, value])

  const selectProps = {
    id: id,
    name: id,
    value: value || '',
    label: label,
    variant: variant,
    disabled: !!disabled,
    style: {
      backgroundColor:
        (!!disabled && 'transparent') || (!!isError && colours.redError),
    },
    onBlur: () => setHasBlurred(true),
    onChange: event =>
      !isReadOnly &&
      onChange(!!isNumeric ? +event.target.value : event.target.value || null),
  }

  return (
    <FormControl fullWidth error={isError}>
      <InputLabel id={id} disabled={!!disabled}>
        {label}
      </InputLabel>
      {!!isMobile ? (
        <Select {...selectProps} native>
          {showEmpty && <option key='empty' value={null} />}
          {isNotInOptions && (
            <option key='hidden' value={value} style={{ display: 'none' }}>
              {value}
            </option>
          )}
          {options.map((op, i) => (
            <option key={i} value={op}>
              {optionLabels?.[i] || op}
            </option>
          ))}
        </Select>
      ) : (
        <Select {...selectProps} labelId={id} readOnly={isReadOnly}>
          {showEmpty && (
            <MenuItem key='empty' value={null}>
              &nbsp;
            </MenuItem>
          )}
          {isNotInOptions && (
            <MenuItem key='hidden' value={value} style={{ display: 'none' }}>
              {value}
            </MenuItem>
          )}
          {options.map((op, i) => (
            <MenuItem key={i} value={op} selected={op === value}>
              {optionLabels?.[i] || op}
            </MenuItem>
          ))}
        </Select>
      )}
      <FormHelperText>{isError ? errorText : helperText}</FormHelperText>
    </FormControl>
  )
}

export default MySelect
